import { ROUTE } from "../../../routes";
import { isFromAndroidWebview } from "../../../configs/utils";
let imageUrl;
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const downloadTemplate = async (action, _datastore, { setDatastore, instrumentTrack }) => {
    const collateralCategory = action.payload.collateralCategory;
    instrumentTrack("DOWNLOAD_COLLATERAL_BUTTON_CLICKED", {
        collateral_category: collateralCategory
    });
    await setDatastore(ROUTE.PREVIEW_COLLATERAL, "previewCollateralScreen", {
        loading: true
    });
    imageUrl = action.payload.imageUrl;
    const imageNameFromAPI = action.payload.imageNameFromAPI;
    const imageFileExtension = action.payload.imageFileExtension;
    fetch(`${imageUrl}`)
        .then((response) => response.blob())
        .then((blob) => {
        if (isFromAndroidWebview()) {
            window.open(imageUrl);
        }
        else {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const a = document.createElement('a');
            a.href = url;
            a.download = `${imageNameFromAPI}.${imageFileExtension}`;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setDatastore(ROUTE.PREVIEW_COLLATERAL, "previewCollateralScreen", {
                loading: false
            });
        }
    })
        .catch((error) => {
        console.log('Preview Collateral Error', error);
    });
};
export const shareOnWhatsAppCollateral = async (action, _datastore, { setDatastore, instrumentTrack }) => {
    await setDatastore(ROUTE.PREVIEW_COLLATERAL, "previewCollateralScreen", {
        loading: true
    });
    imageUrl = action.payload.imageUrl;
    if (isFromAndroidWebview()) {
        window.open(`${imageUrl}shareOnWhatsapp`);
    }
};
